// Trimmed from LC2 (src/app/store/reducers/reducer.js) — session/loading (auth),
// menu/dashboard (app shell nav), and entities (dashboard tables) are ported. Add
// alerts/ui back as each of those pages/features gets ported.
import {combineReducers} from 'redux';

import session from './session';
import loading from './loading';
import menu from './menu';
import dashboard from './dashboard';
import entities from './entities';

import {loyaltyCloudApi} from '../../../features/loyaltyCloudApi/apiSlice';
import {coreApiSlice} from '../../../features/coreApi/apiSlice';
import {actionsApiSlice} from '../../../features/actionsApi/apiSlice';
import {messagingApiSlice} from '../../../features/messagingApi/apiSlice';

const reducer = combineReducers({
    session,
    loading,
    menu,
    dashboard,
    entities,
    [loyaltyCloudApi.reducerPath]: loyaltyCloudApi.reducer,
    [coreApiSlice.reducerPath]: coreApiSlice.reducer,
    [actionsApiSlice.reducerPath]: actionsApiSlice.reducer,
    [messagingApiSlice.reducerPath]: messagingApiSlice.reducer
});

export default reducer;
